import { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { Loader2, Lock } from "lucide-react";
import { useAuth } from "@/context/AuthContext";
import Seo from "@/components/Seo";

const inputCls = "w-full rounded-xl border border-white/10 bg-neutral-900 px-4 py-3 text-sm text-white placeholder:text-neutral-500 focus:border-gold focus:outline-none focus:ring-1 focus:ring-gold";

export default function AdminLogin() {
  const { login, user } = useAuth();
  const navigate = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    if (user) navigate("/admin", { replace: true });
  }, [user, navigate]);

  async function submit(e) {
    e.preventDefault();
    setError("");
    setLoading(true);
    const res = await login(email, password);
    setLoading(false);
    if (res.ok) navigate("/admin", { replace: true });
    else setError(res.error);
  }

  return (
    <>
      <Seo title="Yönetim Girişi | Meguiar's İzmit" noindex />
      <div className="grain flex min-h-screen items-center justify-center bg-neutral-950 px-5">
        <div className="w-full max-w-md">
          <div className="flex flex-col items-center">
            <img src="/logo.png" alt="Meguiar's İzmit" className="h-14 w-14 rounded-lg object-contain" />
            <h1 className="mt-4 font-display text-2xl font-medium text-white">Yönetim Paneli</h1>
            <p className="mt-1 text-sm text-neutral-500">Meguiar's İzmit içerik yönetimi</p>
          </div>
          <form onSubmit={submit} className="mt-8 rounded-2xl border border-white/10 bg-gradient-to-b from-neutral-900 to-neutral-950 p-7" data-testid="admin-login-form">
            {error && <div data-testid="login-error" className="mb-4 rounded-xl border border-red-500/30 bg-red-500/10 px-4 py-3 text-sm text-red-300">{error}</div>}
            <label className="mb-1.5 block text-sm font-medium text-neutral-300">E-posta</label>
            <input data-testid="login-email" type="email" className={inputCls} value={email} onChange={(e) => setEmail(e.target.value)} placeholder="admin@meguiarsizmit.com" />
            <label className="mb-1.5 mt-4 block text-sm font-medium text-neutral-300">Şifre</label>
            <input data-testid="login-password" type="password" className={inputCls} value={password} onChange={(e) => setPassword(e.target.value)} placeholder="••••••••" />
            <button type="submit" disabled={loading} data-testid="login-submit" className="mt-6 inline-flex w-full items-center justify-center gap-2 rounded-xl bg-gold px-6 py-3.5 text-sm font-bold text-black hover:bg-gold-300 transition-colors disabled:opacity-60">
              {loading ? <Loader2 className="h-4 w-4 animate-spin" /> : <Lock className="h-4 w-4" />} Giriş Yap
            </button>
          </form>
        </div>
      </div>
    </>
  );
}
